module.exports = __webpack_public_path__ + "static/img/bg-academic.e86c5a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cartojourney/bg-academic.png
// module id = KNte
// module chunks = 1